const NAV_LIST = [
  {
    id: 1,
    name: 'Home',
    path: '/',
  },
  {
    id: 2,
    name: 'About Us',
    path: '/about',
  },
  {
    id: 3,
    name: '404',
    path: '/404',
  },
];

export default NAV_LIST;
